import {environment} from './environment';
import * as uuidv4 from 'uuid/v4';

export class UtilService {
    static log(context: string, message: any, value: any = '') {
        if (!environment.production) {
            console.log(message, value);
        }
    }

    static error(context: string, message: any, value: any) {
        if (!environment.production) {
            console.error(message, value);
        }
    }

    static randomId() {
        return uuidv4().replace(/-/g, '');
    }

}


// WEBPACK FOOTER //
// ../inline/src/modules/shared/util.service.ts